import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDtcrn6gUl48OVLbSiAtfBa7w78snrlgfY",
  authDomain: "scl018-desafio-ey.firebaseapp.com",
  projectId: "scl018-desafio-ey",
  storageBucket: "scl018-desafio-ey.appspot.com",
  messagingSenderId: "127330469937",
  appId: "1:127330469937:web:9ae3802b6203dc14006d10"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth();

export {db , auth, app};